import { useState } from 'react';
import { FaEnvelope, FaLinkedin, FaGithub, FaMapMarkerAlt } from 'react-icons/fa';

const contactInfo = [
  { icon: <FaEnvelope className="text-violet-400" size={18} />, label: 'Email', value: 'atchayakannan03@gmail.com', href: 'mailto:atchayakannan03@gmail.com', isEmail: true },
  { icon: <FaLinkedin className="text-cyan-400" size={18} />, label: 'LinkedIn', value: 'atchaya-k-713424211', href: 'https://www.linkedin.com/in/atchaya-k-713424211/' },
  { icon: <FaGithub className="text-slate-300" size={18} />, label: 'GitHub', value: 'github.com/atchu33', href: 'https://github.com/atchu33' },
  { icon: <FaMapMarkerAlt className="text-pink-400" size={18} />, label: 'Location', value: 'Chennai, Tamil Nadu | On-site, Hybrid or Remote', href: null },
];

export default function Contact() {
  const [copied, setCopied] = useState(false);

  const handleEmailClick = (e) => {
    navigator.clipboard.writeText('atchayakannan03@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section id="contact" className="relative py-16 md:py-24 overflow-hidden">
      <div className="glow-orb w-80 h-80 bg-violet-600 bottom-0 right-0" />
      <div className="glow-orb w-64 h-64 bg-cyan-500 top-10 left-0" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 scroll-animate">

          <h2 className="section-title gradient-text">Get In Touch</h2>
          <div className="title-line" />
          <p className="section-subtitle text-sm sm:text-base px-2">
            I'm currently open to new opportunities. My inbox is always open!
          </p>
        </div>

        <div className="flex flex-col md:grid md:grid-cols-2 gap-6 items-start">
          {/* Left */}
          <div className="scroll-animate-left w-full">
            <div className="glass-card p-5 sm:p-8">
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-3">Let's work together</h3>
              <p className="text-slate-400 leading-relaxed mb-5 text-sm sm:text-base">
                I'm a Full Stack Developer with 2 years of experience, actively seeking new opportunities
                where I can contribute, grow, and build impactful products. Available to join immediately. If you think I'd be a good fit,
                I'd love to hear from you.
              </p>
              <a href="mailto:atchayakannan03@gmail.com" onClick={handleEmailClick} className="btn-primary inline-flex text-sm">
                <FaEnvelope size={13} /> Send me an email
              </a>
            </div>
          </div>

          {/* Right */}
          <div className="space-y-3 scroll-animate-right w-full">
            {contactInfo.map(item => (
              <div key={item.label} className="glass-card p-3 sm:p-4">
                {item.href ? (
                  <a
                    href={item.href}
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel="noreferrer"
                    onClick={item.isEmail ? handleEmailClick : undefined}
                    className="flex items-center gap-3 group"
                  >
                    <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{ background: 'rgba(255,255,255,0.05)' }}>
                      {item.icon}
                    </div>
                    <div className="min-w-0">
                      <p className="text-xs text-slate-500 mb-0.5">{item.label}</p>
                      <p className="text-sm font-medium text-slate-300 group-hover:text-violet-400 transition-colors truncate">
                        {item.value}
                      </p>
                    </div>
                  </a>
                ) : (
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-xl flex items-center justify-center flex-shrink-0"
                      style={{ background: 'rgba(255,255,255,0.05)' }}>
                      {item.icon}
                    </div>
                    <div>
                      <p className="text-xs text-slate-500 mb-0.5">{item.label}</p>
                      <p className="text-sm font-medium text-slate-300">{item.value}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      {copied && (
        <div className="fixed bottom-5 right-5 bg-slate-900/90 text-violet-400 border border-violet-500/30 px-4 py-2.5 rounded-xl shadow-xl backdrop-blur-sm text-sm font-semibold z-50 flex items-center gap-2" style={{ animation: 'bounce 1s infinite' }}>
          <span>📧 Email copied to clipboard!</span>
        </div>
      )}
    </section>
  );
}
